// Home page

// _____________________________________________________________

// Libraries
import React from 'react'

// Components
import Layout from '../components/Layout'
import SEO from '../components/SEO'
import HomePage from '../components/HomePage'

// _____________________________________________________________

const Index = () => {
  return (
    <>
      <SEO />
        <HomePage />
    </>
  )
}

export default Index
